import styled from 'styled-components';

export const Container = styled.div`
  .key-value {
    align-items: baseline;

    span:first-child {
      font-size: 14px;
    }
    span:last-child {
      line-height: 21px;
    }
  }
`;

export const ContainerButtons = styled.div`
  padding-top: 28px;
  margin: 28px 0 12px 0;
  border-top: solid 1px #4b4e53;
`;

export const ContainerTypeStrike = styled.div`
  display: flex;
  align-items: center;

  & > div {
    width: 40px;
    margin: 0 12px;
  }
`;

export const ContainerPrice = styled.div`
  margin-top: 28px;
  padding-top: 28px;
  border-top: solid 1px #4b4e53;

  .date-quote {
    padding: 8px;
    background: #5a5c62;
    margin-bottom: 32px;
  }

  .commission {
    p {
      width: 86px;
      font-size: 14px;
    }

    & > div {
      width: 86px;
      margin: 0 15px;
    }
  }
`;
